module.exports = __webpack_public_path__ + "img/ring_y_i_1_1.ed92f49b.png";